import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { UserStoreService } from '@gah-core/services/user-store.service';
import { HomeTitles } from '@modules/home/models/home-titles.model';
import { GoogleanalyticsmoduleserviceService } from '@shared/services/googleanalyticsmoduleservice.service';
import moment from 'moment';

@Component({
  selector: 'app-home-title',
  templateUrl: './home-title.component.html',
  styleUrls: ['./home-title.component.scss'],
})
export class HomeTitleComponent implements OnInit {
  @Input() title: HomeTitles;
  @Input() isOnRelease: boolean;
  @Input() isNewAssets: boolean = false;
  formattedReleaseDate: string;
  formattedFirstPreviewDate: string;
  hoverPopup: boolean = false;
  keepPopupShown: boolean = false;
  showTitle: boolean = false;
  dateFormat: string;
  categories: any = [];

  constructor(private router: Router, private userStoreService: UserStoreService,
              public googleanalyticsmoduleserviceService: GoogleanalyticsmoduleserviceService) {}

  ngOnInit(): void {
    this.dateFormat = this.userStoreService.userState.defaultDateFormat;
    if (this.title.releaseDate) {
      this.formattedReleaseDate = this.calculateReleaseDate(this.title);
    }
    if (this.title.previewDate) {
      this.formattedFirstPreviewDate = moment(this.title.previewDate).format(this.dateFormat);
    }
    if (this.title.assetCategories) {
      this.categories = this.title.assetCategories.split('\n');
    }
  }

  getThumbnailUrl(thumbnailUrl: string) {
    if (!this.title.thumbnailUrl) {
      this.title.thumbnailUrl = '/assets/img/default_poster.jpg';
      this.showTitle = true;
    }
    if (this.title.thumbnailUrl == '/assets/img/default_poster.jpg') {
      this.showTitle = true;
    }
    return this.title.thumbnailUrl;
  }

  titleClick(event: any, title: HomeTitles) {
    this.googleanalyticsmoduleserviceService.sendDataToAnalyticsOnHomePageTitleClick(title, this.isNewAssets);
    var titleName = title.localTitleName ?? title.titleName;
    let params = {};
    if (this.isNewAssets) {
      params = { isNewAssets: this.isNewAssets };
    }
    this.router.navigate(['/assets/' + title.titleId], {
      state: { titleName },
      queryParams: params,
    });
  }

  hidePopoverTitle() {
    setTimeout(() => {
      if (!this.keepPopupShown) this.hoverPopup = false;
    }, 500);
  }
  showPopoverTitle() {
    this.hoverPopup = true;
  }
  hidePopover() {
    this.hoverPopup = false;
    this.keepPopupShown = false;
  }
  showPopover() {
    this.hoverPopup = true;
    this.keepPopupShown = true;
  }

  getWebsite(website: string) {
    let websiteArr: string[] = [];
    if (website) {
      website.split('||').forEach((afterSplitByPipe: string) => {
        websiteArr.push(afterSplitByPipe);
      });
    }
    return websiteArr.join('~'); //gahr-1242, separator changed for proper link text
  }

  /**
   * Function - Calculate release date based on release date precision flags (GAHR-467)
   * @param data
   * @returns releasedate
   */
  calculateReleaseDate(data?: any) {
    var months = [
      'January',
      'February',
      'March',
      'April',
      'May',
      'June',
      'July',
      'August',
      'September',
      'October',
      'November',
      'December',
    ];
    var dt;
    var month;
    var year;
    var result = '';

    if (data.releaseDate) {
      if (data.releaseDatePrecisionFlag == 'M') {
        dt = new Date(data.releaseDate);
        month = months[dt.getMonth()];
        year = dt.getFullYear();
        result = '';
        result = month + ' ' + year;
        return result;
      } else if (data.releaseDatePrecisionFlag == 'Y') {
        moment(data.releaseDate);
        dt = new Date(data.releaseDate);
        year = dt.getFullYear();
        result = '';
        result = year.toString();
        return result;
      } else if (data.releaseDatePrecisionFlag == 'Q') {
        moment(data.releaseDate);
        dt = new Date(data.releaseDate);
        year = dt.getFullYear();
        month = dt.getMonth();
        result = '';
        if (month < 4) {
          result = 'Q1' + ' ' + year;
        } else if (month > 3 && month < 7) {
          result = 'Q2' + ' ' + year;
        } else if (month > 6 && month < 10) {
          result = 'Q3' + ' ' + year;
        } else {
          result = 'Q4' + ' ' + year;
        }
        return result;
      } else {
        return moment(data.releaseDate).format(this.dateFormat);
      }
    } else {
      return '';
    }
  }
}
